// extracted by mini-css-extract-plugin
export default {"featured_stories":"FeaturedStories_featured_stories__ed2SR","containers":"FeaturedStories_containers__zApcX","heading":"FeaturedStories_heading__E1F8o"};